export function joinNameParts(...parts) {
  return parts
    .flat()
    .map((part) => `${part || ''}`.trim())
    .filter(Boolean)
    .join(' ');
}

export function buildSurname(person) {
  return joinNameParts(person?.surname, person?.secondSurname);
}

export function buildFullName(person) {
  return joinNameParts(person?.name, person?.surname, person?.secondSurname);
}
